var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sku-test-trek__cta"},[_c('a',{staticClass:"button button--primary button--hollow",class:_vm.cssClass,attrs:{"href":_vm.url,"target":_vm.target},domProps:{"innerHTML":_vm._s(_vm.linkName)}})])}
var staticRenderFns = []

export { render, staticRenderFns }